import { Field as BaseField } from "@base-ui/react/field";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./Field.module.css";

const Root = React.forwardRef(
  ({ disabled = false, className, children, ...rest }, ref) => (
    <BaseField.Root
      ref={ref}
      className={clsx(css.root, className)}
      disabled={disabled}
      {...rest}
    >
      {children}
    </BaseField.Root>
  ),
);

Root.displayName = "FieldRoot";

Root.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Label = React.forwardRef(({ className, children, ...rest }, ref) => (
  <BaseField.Label ref={ref} className={clsx(css.label, className)} {...rest}>
    {children}
  </BaseField.Label>
));

Label.displayName = "FieldLabel";

Label.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Control = React.forwardRef(({ className, ...rest }, ref) => (
  <BaseField.Control
    ref={ref}
    className={clsx(css.control, className)}
    {...rest}
  />
));

Control.displayName = "FieldControl";

Control.propTypes = {
  className: PropTypes.string,
};

const Description = React.forwardRef(
  ({ className, children, ...rest }, ref) => (
    <BaseField.Description
      ref={ref}
      className={clsx(css.description, className)}
      {...rest}
    >
      {children}
    </BaseField.Description>
  ),
);

Description.displayName = "FieldDescription";

Description.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const Error = React.forwardRef(({ className, children, ...rest }, ref) => (
  <BaseField.Error ref={ref} className={clsx(css.error, className)} {...rest}>
    {children}
  </BaseField.Error>
));

Error.displayName = "FieldError";

Error.propTypes = {
  match: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

const { Validity } = BaseField;

const Field = {
  Root,
  Label,
  Control,
  Description,
  Error,
  Validity,
};

export default Field;
